export function buildInfrastructureAdminRoutes(harborConsoleUrl: string) {
  return [
    {
      path: "/ops-center",
      name: "opsCenter",
      icon: "control",
      access: "canManagePlatform",
      routes: [
        {
          path: "",
          redirect: "/ops-center/dashboard",
        },
        {
          path: "dashboard",
          name: "opsCenterDashboard",
          icon: "dashboard",
          component: "./platform-ops-center/DashboardPage",
        },
        {
          path: "modules",
          name: "opsCenterModules",
          icon: "appstore",
          component: "./platform-ops-center/ModulesPage",
        },
        {
          path: "service-endpoints",
          redirect: "/ops-center/modules?tab=registry",
        },
        {
          path: "logs",
          name: "opsCenterLogs",
          icon: "fileSearch",
          component: "./platform-ops-center/LogQueryPage",
        },
        {
          path: "mq-observability",
          name: "opsCenterMqObservability",
          icon: "monitor",
          component: "./platform-ops-center/MqObservabilityPage",
        },
        {
          path: "redis-observability",
          name: "opsCenterRedisObservability",
          icon: "database",
          component: "./platform-ops-center/RedisObservabilityPage",
        },
        {
          path: "worker-observability",
          name: "opsCenterWorkerObservability",
          icon: "cluster",
          component: "./platform-ops-center/WorkerObservabilityPage",
        },
        {
          path: "event-delivery-observability",
          name: "opsCenterEventDeliveryObservability",
          icon: "deploymentUnit",
          component: "./platform-ops-center/EventDeliveryObservabilityPage",
        },
        {
          path: "execution-chain-observability",
          name: "opsCenterExecutionChainObservability",
          icon: "partition",
          component: "./platform-ops-center/ExecutionChainObservabilityPage",
        },
        {
          path: "contract-health-observability",
          name: "opsCenterContractHealthObservability",
          icon: "audit",
          component: "./platform-ops-center/ContractHealthObservabilityPage",
        },
        {
          path: "auth-health-observability",
          name: "opsCenterAuthHealthObservability",
          icon: "safetyCertificate",
          component: "./platform-ops-center/AuthHealthObservabilityPage",
        },
      ],
    },
    {
      path: "/assets-center",
      name: "assetsCenter",
      icon: "database",
      access: "canManageAssets",
      routes: [
        {
          path: "",
          redirect: "/assets-center/dashboard",
        },
        {
          path: "dashboard",
          name: "assetsDashboard",
          icon: "dashboard",
          component: "./platform-assets/DashboardPage",
        },
        {
          path: "assets",
          name: "assetsGovernance",
          icon: "database",
          component: "./platform-assets/AssetsPage",
        },
        {
          path: "object-spaces",
          name: "assetsObjectSpaces",
          icon: "partition",
          component: "./platform-assets/ObjectSpacesPage",
        },
        {
          path: "references",
          name: "assetsReferences",
          icon: "book",
          component: "./platform-assets/ReferencesPage",
        },
        {
          path: "public-branding",
          name: "assetsPublicBranding",
          icon: "highlight",
          component: "./platform-assets/PublicBrandingPage",
        },
      ],
    },
    {
      path: "/environment-center",
      name: "environmentCenter",
      icon: "appstore",
      access: "canManageEnvironment",
      routes: [
        {
          path: "",
          redirect: "/environment-center/dashboard",
        },
        {
          path: "dashboard",
          name: "environmentDashboard",
          icon: "dashboard",
          component: "./platform-environment/DashboardPage",
        },
        {
          path: "",
          key: "environment-kvm",
          name: "environmentKvm",
          icon: "desktop",
          routes: [
            {
              path: "/environment-center/vm-specs",
              name: "environmentVmSpecs",
              icon: "desktop",
              component: "./platform-environment/VmSpecsPage",
            },
            {
              path: "/environment-center/base-images",
              name: "environmentBaseImages",
              icon: "hdd",
              component: "./platform-environment/BaseImagesPage",
            },
            {
              path: "/environment-center/image-artifact-tasks",
              name: "environmentImageArtifactTasks",
              icon: "hdd",
              component: "./platform-environment/ImageArtifactTasksPage",
            },
            {
              path: "/environment-center/application-images",
              name: "environmentApplicationImages",
              icon: "layout",
              component: "./platform-environment/ApplicationImagesPage",
            },
            {
              path: "/environment-center/custom-images",
              name: "environmentCustomImages",
              icon: "copy",
              component: "./platform-environment/CustomImagesPage",
            },
            {
              path: "/environment-center/system-core-images",
              name: "environmentSystemCoreImages",
              icon: "safetyCertificate",
              component: "./platform-environment/SystemCoreImagesPage",
            },
            {
              path: "/environment-center/cloud-init-profiles",
              name: "environmentCloudInitProfiles",
              icon: "fileProtect",
              component: "./platform-environment/CloudInitProfilesPage",
            },
          ],
        },
        {
          path: "",
          key: "environment-container",
          name: "environmentContainer",
          icon: "container",
          routes: [
            {
              path: "/environment-center/container-specs",
              name: "environmentContainerSpecs",
              icon: "container",
              component: "./platform-environment/ContainerSpecsPage",
            },
            {
              path: "/environment-center/container-images",
              name: "environmentContainerImages",
              icon: "container",
              component: "./platform-environment/ContainerImagesPage",
            },
          ],
        },
        {
          path: "",
          key: "environment-dynamips",
          name: "environmentDynamips",
          icon: "cluster",
          routes: [
            {
              path: "/environment-center/dynamips-ios-images",
              name: "environmentDynamipsIosImages",
              icon: "hdd",
              component: "./platform-environment/DynamipsIosImagesPage",
            },
            {
              path: "/environment-center/dynamips-specs",
              name: "environmentDynamipsSpecs",
              icon: "cluster",
              component: "./platform-environment/DynamipsSpecsPage",
            },
          ],
        },
        {
          path: "",
          key: "environment-firecracker",
          name: "environmentFirecracker",
          icon: "thunderbolt",
          routes: [
            {
              path: "/environment-center/microvm-specs",
              name: "environmentMicrovmSpecs",
              icon: "thunderbolt",
              component: "./platform-environment/MicrovmSpecsPage",
            },
            {
              path: "/environment-center/firecracker-kernels",
              name: "environmentFirecrackerKernels",
              icon: "fileProtect",
              component: "./platform-environment/FirecrackerKernelsPage",
            },
            {
              path: "/environment-center/firecracker-rootfs-images",
              name: "environmentFirecrackerRootfsImages",
              icon: "hdd",
              component: "./platform-environment/FirecrackerRootfsImagesPage",
            },
            {
              path: "/environment-center/firecracker-application-images",
              name: "environmentFirecrackerApplicationImages",
              icon: "appstore",
              component: "./platform-environment/FirecrackerApplicationImagesPage",
            },
          ],
        },
        {
          path: "",
          key: "environment-simulator",
          name: "environmentSimulator",
          icon: "experiment",
          routes: [
            {
              path: "/environment-center/simulator-models",
              name: "environmentSimulatorModels",
              icon: "experiment",
              component: "./platform-environment/SimulatorModelsPage",
            },
          ],
        },
        {
          path: "image-port-service-protocols",
          name: "environmentImagePortServiceProtocols",
          icon: "api",
          component: "./platform-environment/ImagePortServiceProtocolsPage",
        },
        {
          path: "physical-devices",
          name: "environmentPhysicalDevices",
          icon: "apartment",
          component: "./platform-environment/PhysicalDevicesPage",
        },
        {
          path: "",
          key: "environment-topology",
          name: "environmentTopology",
          icon: "deploymentUnit",
          routes: [
            {
              path: "/environment-center/topology-templates",
              name: "environmentTopologyTemplates",
              icon: "deploymentUnit",
              component: "./platform-environment/TopologyTemplatesPage",
            },
            {
              path: "/environment-center/topology-versions",
              name: "environmentTopologyVersions",
              icon: "branches",
              component: "./platform-environment/TopologyVersionsPage",
            },
            {
              path: "/environment-center/topology-default-image-policy",
              name: "environmentTopologyDefaultImagePolicy",
              icon: "setting",
              component: "./platform-environment/TopologyDefaultImagePolicyPage",
            },
          ],
        },
        ...(harborConsoleUrl
          ? [
              {
                path: harborConsoleUrl,
                name: "environmentHarbor",
                icon: "link",
                target: "_blank",
              },
            ]
          : []),
      ],
    },
  ];
}
